import { AvatarImage } from "@design-system/components";
import React from "react";

function FallbackLogo() {
  return <AvatarImage src="/spirii-icon.svg" alt="Logo" />;
}

export { FallbackLogo };
